/**
 * Detecta el fallo de carga de un chunk lazy (`import()` dinámico).
 *
 * Causa típica: tras un deploy nuevo, un `index.html` cacheado referencia un hash
 * de bundle que ya no existe en el server → el `import()` del chunk rechaza.
 *
 * Cubre las dos variantes de mensaje según el bundler:
 *  - webpack:            `ChunkLoadError` / `Loading chunk 42 failed`
 *  - esbuild/Vite (Angular actual): `Failed to fetch dynamically imported module: …`
 *
 * Es la ÚNICA fuente de verdad de esta detección: la usan el `GlobalErrorHandler`
 * (red de contención global) y el login local (recuperación tras la navegación
 * post-login). No dupliquen la regex.
 */
export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return /ChunkLoadError|Loading chunk .* failed|dynamically imported module/i.test(message);
}
